import { useQuery } from "react-query";
import {
	get_all_categories_api,
	add_food_categories,
	update_food_categories,
	delete_category_by_id_api,
	get_all_sub_categories_api,
} from "../services/categories";
import { useMutation } from "react-query";

export const useGetAllCategories = (params) =>
	useQuery(["getAllCategories", params], () => get_all_categories_api(params));

export const useAddFoodCategories = () =>
	useMutation("addFoodCategories", (body) => add_food_categories(body));

export const useUpdateFoodCategories = () =>
	useMutation("updateFoodCategories", (body) => update_food_categories(body));

export const useDeleteCategoryById = () =>
	useMutation("deleteCategory", (body) => delete_category_by_id_api(body));

export const useGetAllSubCategories = (params) =>
	useQuery(["getAllCategories", params], () =>
		get_all_sub_categories_api(params)
	);
